module.exports = __webpack_public_path__ + "static/media/zenodo-upload-list.b830f564.png";